






import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
	name: 'routeView',
	computed: {
		notKeep() {
			return this.$route.meta.keepAlive === false
		},
		multiTab() {
			return this.$store.getters.multiTab
		},
		inKeep() {
			return this.$route.meta.keepAlive
		},
	},
})
export default class RouteView extends Vue {}
